import { jsx as _jsx } from "react/jsx-runtime";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
export const DropZoneStyle = styled('div')(({ theme, isDragActive, disabled }) => ({
    backgroundImage: isDragActive
        ? `repeating-linear-gradient(-45deg, ${theme.palette.background.paper}, ${theme.palette.background.paper} 25px, ${theme.palette.divider} 25px, ${theme.palette.divider} 50px)`
        : '',
    backgroundSize: isDragActive ? '150% 100%' : '',
    border: isDragActive ? 'solid' : 'dashed',
    borderColor: isDragActive ? theme.palette.primary.light : theme.palette.divider,
    position: 'relative',
    width: '100%',
    minHeight: '50px',
    bgcolor: 'background.paper',
    borderRadius: 'shape.borderRadius',
    boxSizing: 'border-box',
    cursor: disabled ? 'not-allowed' : 'pointer',
    overflow: 'hidden',
}));
export const LightTooltip = styled(({ className, ...props }) => (_jsx(Tooltip, { ...props, classes: { popper: className } })))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.mode === 'dark' ? '#f0f0f0' : '#474747',
        boxShadow: theme.shadows[1],
        fontSize: 11,
    },
}));
